import { createSlice } from '@reduxjs/toolkit';
import type { StoreLocatorData } from '../../domain/models/StoreLocatorData';

export const STORE_LOCATOR_INITIAL_SLICE_NAME = 'storeLocatorInitial';

export interface StoreLocatorInitialState {
  /** Locator payload from SSR. The page reads this because RTK cache is not always visible on first paint. */
  data: StoreLocatorData | null;
}

const initialState: StoreLocatorInitialState = {
  data: null,
};

const storeLocatorInitialSlice = createSlice({
  name: STORE_LOCATOR_INITIAL_SLICE_NAME,
  initialState,
  reducers: {
    setStoreLocatorInitialData(state, action: { payload: StoreLocatorData | null }) {
      state.data = action.payload ?? null;
    },
  },
});

export const storeLocatorInitialReducer = storeLocatorInitialSlice.reducer;
export const { setStoreLocatorInitialData } = storeLocatorInitialSlice.actions;

export function selectStoreLocatorInitialData(state: {
  [STORE_LOCATOR_INITIAL_SLICE_NAME]?: StoreLocatorInitialState;
}): StoreLocatorData | null {
  return state[STORE_LOCATOR_INITIAL_SLICE_NAME]?.data ?? null;
}
